import instance from './axios'

export const getHomeBanner = (params = {}) => instance.get('/app-api/promotion/banner/list', { params })
export const articleLists = (params = {}) => instance.get('/app-api/promotion/article/page', {params} )
export const articleDetail = (params = {}) => instance.get('/app-api/promotion/article/get', {params} )


export const messageCreate = (params = {}) => instance.post('/app-api/museum/message/create', params )


export const spuLists = (params = {}) => instance.get('/app-api/product/spu/page', {params} )
export const spuDetail = (params = {}) => instance.get('/app-api/product/spu/get-detail', {params} )


export const classification = (params = {}) => instance.get('/app-api/museum/antique/classification', {params} )
export const antiqueLists = (params = {}) => instance.get('/app-api/museum/antique/page', {params} )
export const antiqueDetail = (params = {}) => instance.get('/app-api/museum/antique/get', {params} )
export const getHeritageLists = (params = {}) => instance.get('/app-api/museum/cultural-heritage/page', {params} )
export const getHeritageDetail = (params = {}) => instance.get('/app-api/museum/cultural-heritage/get?id='+params.id )


// 获取电子图书分页
export const getEbookLists = (params = {}) => instance.get('/app-api/museum/books/page', {params} )
export const getResourceLists = (params = {}) => instance.get('/app-api/museum/resource/page', {params} )
// 获取影音库资源分类列表
export const getResourceCategoryList = (params = {}) => instance.get('/app-api/museum/resource/category/list', {params} )
// 获取电子图书详情
export const getEbookDetail = (params = {}) => instance.get('/app-api/museum/books/get?id='+params.id)
// 获取活动的分页
export const getActivityLists = (params = {}) => instance.get('/app-api/museum/activity/page', {params} )
// 增加电子图书的浏览量
export const addEbookView = (params = {}) => instance.put('/app-api/museum/books/add-read-num', params)
// 增加电子图书的点赞
export const addEbookLike = (params = {}) => instance.put('/app-api/museum/books/add-like-num', params)
// 浏览量
export const addPV = () => instance.post('/app-api/infra/pv-statistics/add');
